import { GetterTree } from 'vuex';
import { LoginState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<LoginState, RootState> = {};
